import { BlocksIconArrowExpand } from 'blocks-nextjs/blocks-web-components/components/icon/icons/arrow-expand';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconArrowExpand = createComponent({ react: React, tagName: 'cat-icon-arrow-expand', elementClass: BlocksIconArrowExpand });
